import { z } from 'zod';

/**
 * Un element ajoute A LA MAIN a une liste (« ajouter des choses dans la checklist sans
 * passer par l'IA », retour du porteur du 2026-08-27). Memes bornes que les elements
 * produits par le cerveau (checklistPayloadSchema.items) : 1 a 120 caracteres.
 */
export const ajoutElementSchema = z.object({
  label: z.string().trim().min(1, 'Un élément ne peut pas être vide').max(120),
});

export type AjoutElement = z.infer<typeof ajoutElementSchema>;
